import {useCallback} from 'react';

import {KYC_DECLINED_EVENTS} from '@/app/auth/events/KycDeclinedEvents';
import {PROJECT_TAGS} from '@/constants';
import {useTrackingManager} from '@/hooks';

export interface IAdIdsTrack {
  provider?: string;
  id?: string;
}

export const useTrackers = () => {
  const {trackEvent} = useTrackingManager();

  const trackViewKycDeclined = useCallback(() => {
    trackEvent(KYC_DECLINED_EVENTS.VIEW_KYC_DECLINED_PAGE, {
      project_tag: PROJECT_TAGS.ONBOARDING,
    });
  }, [trackEvent]);

  const trackViewKycDeclinedSupport = useCallback(() => {
    trackEvent(KYC_DECLINED_EVENTS.SELECT_KYC_DECLINED_SUPPORT, {
      project_tag: PROJECT_TAGS.ONBOARDING,
    });
  }, [trackEvent]);

  return {
    trackViewKycDeclinedSupport,
    trackViewKycDeclined,
  };
};
